import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SparkleIcon } from '@moia-dev/pace-icons'
import { AnnotationTriageAreaRoutes } from './AnnotationTriageAreaRoutes'

export const AnnotationTriageAreaNavigationIcon = SparkleIcon

export const AnnotationTriageAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AnnotationTriageAreaRoutes.route}
      Icon={SparkleIcon}
    />
  )
}
